import { useContext } from 'react';
import { translateKey } from '../../../../../translate';
import { createEnumeration } from '../../../../../utils/enumeration';
import { KgbSuccessPage } from '../../../../elements/KgbSuccessPage';
import { OrganizationAddCarePathContext } from '../organizationAddCarePathContext';

interface ISuccessAndSummaryProps {
    organizationName: string;
}

export function SuccessAndSummary(props: ISuccessAndSummaryProps) {
    const { addCarePathState } = useContext(OrganizationAddCarePathContext);

    return (
        <KgbSuccessPage
            buttonText={translateKey('carePath.backToOrganizationOverview')}
            linkTo={`/organizations/${addCarePathState.organizationId}/view`}
            text={createText()}
            title={translateKey('organization.successful')}
        />
    );

    function createText() {
        const text = translateKey('carePath.organizationCanNowUse', props.organizationName);
        const enumeration = createEnumeration(
            (addCarePathState.serviceGroups ?? []).map((serviceGroup) => serviceGroup.name)
        );

        return `${text} ${enumeration}`;
    }
}
